/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {CardsWidget17, EngageWidget10} from '../../../_metronic/partials/widgets'
import {CardsWidget18} from '../../../_metronic/partials/widgets/_new/cards/CardWidget18'
import useUser from '../../hooks/useUser'
import {PremiumCard} from '../../../_metronic/partials/widgets/_new/cards/PremumCard'
import {TransactionsCard} from '../../../_metronic/partials/widgets/_new/cards/TransactionsCard'
// import {GET_MONTHLY_USER_ANALYTICS} from '../../queries/user.query'

type chartData = {
  totalUsers: ''
  totalBusinessUsers: ''
  totalIndividualUsers: ''
  totalClasses: ''
  totalBookings: ''
  totalClients: ''
  totalBookings7: ''
  totalBookings30: ''
  totalPremiumUsers: ''
  totalPremiumBusiness: ''
  totalPremiumIndividuals: ''
  totalTransactions: ''
  totalTransactions7: ''
  totalTransactions30: ''
}
const DashboardPage: FC = () => {
  const {getAnalytics} = useUser()
  const [chartData, setChartData] = useState<chartData>({
    totalUsers: '',
    totalBusinessUsers: '',
    totalIndividualUsers: '',
    totalClasses: '',
    totalBookings: '',
    totalClients: '',
    totalBookings7: '',
    totalBookings30: '',
    totalPremiumUsers: '',
    totalPremiumBusiness: '',
    totalPremiumIndividuals: '',
    totalTransactions: '',
    totalTransactions7: '',
    totalTransactions30: '',
  })

  useEffect(() => {
    const init = async () => {
      try {
        const {data, status} = await getAnalytics()
        setChartData(data)
      } catch (error) {
        console.log(error)
      }
    }

    init()
  }, [])
  return (
    <>
      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        {/* begin::Col */}
        {/* <div className='col-md-12 col-lg-12 col-xl-12 col-xxl-6 mb-md-5 mb-xl-10'> */}
        {/* <div className='col-sm-6 col-lg-3 min-h-200px'>
          <CardsWidget20
            className='h-200px mb-5 mb-xl-10'
            cardNumber={`${albumCount?.audioAlbum}`}
            description='Audio Albums'
            progressNumber=''
            progressBar='ongoing contest'
            color='#F1416C'
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
          />
        </div> */}
        {/* <div className='col-sm-6 col-lg-3 min-h-200px'>
          <CardsWidget20
            className='h-200px mx-1 mb-5 mb-xl-10'
            cardNumber={`${mediaData?.audioCount}`}
            description='Individual Audios'
            progressNumber=''
            progressBar='ongoing contest'
            color='#F1416C'
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
          />
        </div>

        <div className='col-sm-6 col-lg-3 min-h-200px'>
          <CardsWidget20
            className='h-200px mx-1 mb-5 mb-xl-10'
            cardNumber={`${albumCount?.videoAlbum}`}
            description='Video Albums'
            progressNumber=''
            progressBar='ongoing contest'
            color='#F1416C'
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
          />
        </div>
        <div className='col-sm-6 col-lg-3 min-h-200px col-sm-6'>
          <CardsWidget20
            className='h-200px mb-5 mb-xl-10'
            cardNumber={`${mediaData?.videoCount}`}
            description='Individual Videos'
            progressNumber='437'
            progressBar='total users'
            color='#F1416C'
            img={toAbsoluteUrl('/media/patterns/vector-1.png')}
          />
        </div> */}
        <div className='col-md-6 h-md-50 h-lg-50 col-lg-6 col-xl-6 col-xxl-6 mb-md-5 mb-xl-10'>
          <CardsWidget18 chartData={chartData} className='h-md-50 mb-5 mb-xl-10' />
        </div>

        <div className='col-md-6 h-md-50 h-lg-50 col-lg-6 col-xl-6 col-xxl-6 mb-md-5 mb-xl-10'>
          <CardsWidget17 chartData={chartData} className='h-md-50 mb-5 mb-xl-10' />
        </div>

        <div className='col-md-6 h-md-50 h-lg-50 col-lg-6 col-xl-6 col-xxl-6 mb-md-5 mb-xl-10'>
          <PremiumCard chartData={chartData} className='h-md-50 mb-5 mb-xl-10' />
        </div>
        <div className='col-md-6 h-md-50 h-lg-50 col-lg-6 col-xl-6 col-xxl-6 mb-md-5 mb-xl-10'>
          <TransactionsCard chartData={chartData} className='h-md-50 mb-5 mb-xl-10' />
        </div>
        {/* </div> */}
        {/* end::Col */}

        {/* begin::Col */}
        {/* <div className='col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-md-5 mb-xl-10'>
          <ListsWidget26 className='h-lg-50' />
        </div> */}
        {/* end::Col */}
      </div>

      {/* begin::Col */}
      {/* <div className='col-12 '>
        <EngageWidget10 className='h-md-100' />
      </div> */}
      {/* end::Col */}

      {/* begin::Row */}
      {/* <div className='row gy-5 g-xl-8'>
      <div className='col-xl-4'>
        <ListsWidget2 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget6 className='card-xl-stretch mb-xl-8' />
      </div>
      <div className='col-xl-4'>
        <ListsWidget4 className='card-xl-stretch mb-5 mb-xl-8' items={5} />
      </div>
    </div> */}
      {/* partials/widgets/lists/_widget-4', 'class' => 'card-xl-stretch mb-5 mb-xl-8', 'items' => '5' */}
      {/* end::Row */}

      {/* <div className='row g-5 gx-xxl-8'>
      <div className='col-xxl-4'>
        <MixedWidget8
          className='card-xxl-stretch mb-xl-3'
          chartColor='success'
          chartHeight='150px'
        />
      </div>
      <div className='col-xxl-8'>
        <TablesWidget5 className='card-xxl-stretch mb-5 mb-xxl-8' />
      </div>
    </div> */}
    </>
  )
}

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <DashboardPage />
    </>
  )
}

export {DashboardWrapper}
